export default {
      id: "i-banner-pif-usage",
      viewBox: "45 15 320 320",
      url: __webpack_public_path__ + "img/sprite.svg#i-banner-pif",
      toString: function () {
        return this.url;
      }
    }